import "./TakeawaySuccess.scss";

import { useLayoutEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";
import api_key from "../../../env";
import QRCode from "qrcode";
import { getOrgOrder } from "../../../utility";
import getOrganization from "../../../utility/getOrganization";
import Banner from "../../../components/Banner";
import BannerImage from "../../../components/img/banner-bg.png";
import Header from "../../../components/Header";
import SocialNetworks from "../../../components/socialNetworks/SocialNetworks";
import OutlinedPinkButton from "../../../components/buttons/outlinedPinkButton/OutlinedPinkButton";
import Lottie from "lottie-react";
import OrderReceived from "../../../components/lotties/orderReceived";
import DefaulOrgImage from "../../../components/logos/logo.svg";

function TakeawaySuccess() {
  const { t } = useTranslation("takeaway");
  const [orgName, setOrgName] = useState("Chargement...");
  const [org, setOrg] = useState({});
  const { orgId, orderId } = useParams();
  const [qrTicket, setQrTicket] = useState();
  const [order, setOrder] = useState({});

  useLayoutEffect(() => {
    if (orderId) {
      fetchOrders();
      fetchOrg();
      setQrCodeHandler();
    }
  }, [orderId]);

  const setQrCodeHandler = async () => {
    try {
      const qrcode = await QRCode.toDataURL(orderId, {
        scale: 12,
      });
      setQrTicket(qrcode);
    } catch (err) {
      console.error(err);
    }
  };

  async function fetchOrders() {
    const order = await getOrgOrder(orgId, orderId);
    setOrder(order.order);
  }

  async function fetchOrg() {
    const org = await getOrganization(orgId);
    setOrg(org.org);
    setOrgName(org?.org?.organization);
  }

  function handleDownloadQr() {
    const link = document.createElement("a");
    link.href = qrTicket;
    link.download = `qr-code-${orderId}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <>
      <Header />
      <Banner event={{ name: orgName, imageUrl: BannerImage }} />

      <div className="takeaway-success-content">
        <div className="order">
          <div className="header">
            <p>
              {t("order_number")} {order?.createdAt?.slice(-4)}
            </p>
          </div>

          <hr />

          <div className="body">
            <div className="body-details">
              <p className="body-details-title">Details</p>
              <div className="body-details-container">
                <div className="body-details-total">
                  <p>{t("total")}</p>
                  <p>{order.paidAmount}€</p>
                </div>
                <hr className="body-details-total-separator" />
                {order &&
                  order?.products?.map((item, index) => {
                    return (
                      <>
                        <div key={index} className="body-details-item">
                          <p>{item.title}</p>
                          <p>X{item.quantity}</p>
                        </div>
                        {index !== order?.products?.length - 1 && (
                          <hr className="body-details-item-separator" />
                        )}
                      </>
                    );
                  })}
              </div>
            </div>

            <div className="body-qrCode">
              {order.received ? (
                <>
                  <p className="orderReceived-title">{t("order_confirmed")}</p>
                  <Lottie
                    animationData={OrderReceived}
                    className="orderReceived-lottie"
                    speed={1}
                  />
                  <p className="orderReceived-subtitle">{t("thank_you_for_trust")}</p>
                </>
              ) : (
                <>
                  <p className="body-qrCode-title">{t("qr_code")}</p>
                  <div className="body-qrCode-container">
                    <p className="body-qrCode-subTitle">
                      {t("present_with_qr_code_at")}{" "}
                      {new Date(Number(order.createdAt) + 60 * 60 * 1000).toLocaleString("fr-FR", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </p>
                    <img src={qrTicket} alt="QR Code" />
                    <OutlinedPinkButton onPressFunction={handleDownloadQr}>
                      {t("download_qr_code")}
                    </OutlinedPinkButton>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="__bottom_wrapper">
          <div className="__localization-form">
            <h3 className="__localization-form-title">{t("localization")}</h3>

            <div className="col-12">
              <div className="__ticket-location">
                <div className="__ticket-location-cont">
                  <div className="__ticket-location-innercont">
                    <span className="info">{t("your_address")}</span>
                    <span className="subtitle">{t("your_address_subtitle")}</span>
                  </div>
                  <div className="right-detail">
                    <div className="apply-promo-container">
                      <button onClick={() => {}} className="applyPromo">
                        {t("show_on_map")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ticket-map">
                <APIProvider apiKey={api_key.google_maps_api_key}>
                  <Map
                    defaultCenter={{
                      lat: 50.840329972,
                      lng: 4.3499986,
                    }}
                    defaultZoom={17}
                    gestureHandling={"greedy"}
                    disableDefaultUI={false}
                  >
                    <Marker
                      position={{
                        lat: 50.840329972,
                        lng: 4.3499986,
                      }}
                    />
                  </Map>
                </APIProvider>
              </div>
            </div>
          </div>

          <div className="__ticket-calendar">
            <h3 className="__ticket-calendar-title">{t("contact")}</h3>
            {org !== null && (
              <div className="__ticket-contact-details">
                <div className="__ticket-contact-area">
                  <div className="__ticket-contact-area-container">
                    <div className="__ticket-contact-area-image">
                      <img src={org.logo || DefaulOrgImage} alt={t("logo")} />
                    </div>
                    <div className="__ticket-contact-area-title">
                      <div className="title">{org.organization}</div>
                      <div className="email">
                        {org.adminEmail !== null &&
                          org?.adminEmail?.length > 0 &&
                          org.adminEmail[0]}
                      </div>
                    </div>
                  </div>
                  <div className="__ticket-contact-area-button">
                    {org.adminEmail && org.adminEmail.length > 0 ? (
                      <a style={{ textDecoration: "none" }} href={`mailto:${org.adminEmail[0]}`}>
                        <button className="contactBtn">{t("contact")}</button>
                      </a>
                    ) : (
                      <button className="contactBtn" disabled>
                        {t("no_contact_available")}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}
            <SocialNetworks />
          </div>
        </div>
      </div>
    </>
  );
}

export default TakeawaySuccess;
